export class RegionPageController {
    public static $inject = ["$scope", "$http", "$filter", "SettingsService"];
    constructor(private $scope, private $http, private $filter, private SettingsService) {
        this.$scope.data = "";
        this.$scope.isHomeRegion = this.isHomeRegion.bind(this);
        this.$scope.setRegion = this.setRegion.bind(this);
        this.$scope.hasFeedback = this.hasFeedBack.bind(this);
    }

    private isHomeRegion() {
        return this.SettingsService.region_page.current_region === this.SettingsService.user.home_region;
    }

    private hasFeedBack() {
        return this.$scope.data !== "";
    }

    private setRegion() {
        this.$http({
            method: "POST",
            url: "/user/home",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            transformRequest: function(obj) {
                const str = [];

                for (const p in obj) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }

                return str.join("&");
            },
            data: { home_region: this.SettingsService.region_page.current_region },
        })
            .then((data, status, headers, config) => {
                this.SettingsService.user.home_region = this.SettingsService.region_page.current_region;
                this.$scope.data = this.$filter("translate")("regions:now-home");
            })
            .catch((data, status, headers, config) => {
                if (status == 401) {
                    document.cookie = "home_region=" + this.SettingsService.region_page.current_region + "; path=/";
                    this.SettingsService.user.home_region = this.SettingsService.region_page.current_region;
                    this.$scope.data = this.$filter("translate")("regions:now-home");
                } else {
                    this.$scope.data = "something went wrong";
                }
            });
    }
}
